import api from "@shop/frontend/web/js/api/index";

export class CartService {
	constructor(params = {}) {
		this.count = 0;

		/* Принимает функцию для отображения */
		this.counterTemplate = params.counterTemplate || false;
		this.$headerCount = document.getElementById("js-header-count");
		this.$headerPrice = this.$headerCount.querySelector(".js-count-price");
		this.$count = this.$headerCount.querySelector(".js-count");
		this.$cartCount = $(".js-count");
	}

	getCount() {
		return api.cart.count().then(res => {
			if (!res) return this.$cartCount.text(0);
			this.count = res.count;
			return this.updateCount();
		});
	}

	updateCount() {

		return this.$cartCount.html(this.renderCountText()).show();
	}
	updateInfo({ count, sum }) {
		if (!count) {
			this.$headerCount.classList.remove("active");
			this.$headerCount.classList.add("visible");
			this.$count.textContent = 0;
			this.$headerPrice.textContent = translator.t("event", "tickets ");
			return false;
		}

		this.$count.textContent = count;
		this.$headerPrice.textContent = sum + " ₽";
		this.$headerCount.classList.add("active");
		this.$headerCount.classList.remove("visible");
	}
	renderCountText() {
		if (!this.counterTemplate) return this.count;
		return this.counterTemplate(this.count);
	}
}

export const cartService = new CartService();
